<div
    class="card-actuation header-actuation gestion-card m-r-6 m-b-6 p-b-15"
    *ngIf="DisplayPanel"
>
    <div
        class="title-height"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 6">
            Contacto con Mutua
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 8">
            Informe Médico
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 9">
            Documento no Médico
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 7">
            Comentarios
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 10">
            Orden
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 14">
            SMS entregado
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 15">
            SMS no entregado
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 16">
            Solicitar Alta
        </div>
        <div class="h3 pr-16 cardHeader" *ngIf="actuationOperation === 17">
            Mantener IT
        </div>
    </div>
    
    <div
        class="inner-card m-t--7"
        [formGroup]="GestionFormGroup.get('Gestion')"
        
    >
        <div class="flow-root column">
            <div class="full-width p-0">
                <div
                    *ngIf="showType"
                    class="widget"
                    fxFlex.gt-sm="40"
                    fxFlex.gt-md="40"
                    fxFlex.gt-lg="40"
                >
                    <mat-form-field
                        class="example-full-width p-r-10"
                        floatLabel="always"
                    >
                        <mat-label>Tipo</mat-label>
                        <mat-select
                            formControlName="Type"
                            (ngModelChange)="toggletInterno($event)"
                        >
                            <mat-option
                                *ngFor="
                                    let item of ActuationTypeList
                                        | listFilter: 'ISPERMIT':true
                                "
                                [value]="item.value"
                            >
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                GestionFormGroup.get(['Gestion', 'Type']) &&
                                GestionFormGroup.get(['Gestion', 'Type'])
                                    .invalid
                            "
                        >
                            <span
                                *ngIf="
                                    GestionFormGroup.get(['Gestion', 'Type']) &&
                                    GestionFormGroup.get(['Gestion', 'Type'])
                                        .errors.required
                                "
                                class="validation-span"
                                >Obligatorio</span
                            >
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="widget">
                    <mat-form-field floatLabel="always" class="w-120 p-r-10">
                        <mat-label>Fecha</mat-label>
                        <input
                            formControlName="Date"
                            matInput
                            [matDatepicker]="date"
                            placeholder="Fecha"
                            (click)="date.open()"
                            class="wid130"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="date"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #date></mat-datepicker>
                        <mat-error
                            *ngIf="
                                GestionFormGroup.get(['Gestion', 'Date'])
                                    .invalid
                            "
                        >
                            <span
                                *ngIf="
                                    GestionFormGroup.get(['Gestion', 'Date'])
                                        .errors
                                        .GestionDateShouldBetweenCommunicationAndToday
                                "
                                class="validation-span"
                            >
                                La fecha debe estar entre la fecha de
                                comunicación y hoy</span
                            >
                        </mat-error>
                        <mat-error
                            *ngIf="
                                GestionFormGroup.get(['Gestion', 'Date'])
                                    .invalid
                            "
                        >
                            <span
                                *ngIf="
                                    GestionFormGroup.get(['Gestion', 'Date'])
                                        .errors.NoFutureDate
                                "
                                class="validation-span"
                            >
                                La fecha de la visita no puede ser superior a
                                hoy</span
                            >
                        </mat-error>
                    </mat-form-field>
                </div>
                <div
                    class="widget checkbox-center"
                    *ngIf="actuationOperation === 7 && isInternoVisible"
                >
                    <div class="w-85">
                        <label>&nbsp;</label>
                        <mat-checkbox formControlName="Interno"
                            >Interno</mat-checkbox
                        >
                    </div>
                </div>
            </div>

            <mat-form-field
                class="example-full-width"
                floatLabel="always"
                *ngIf="
                    actuationOperation !== 7 &&
                    actuationOperation !== 8 &&
                    actuationOperation !== 9 &&
                    actuationOperation !== 10 &&
                    actuationOperation !== 14 &&
                    actuationOperation !== 15 &&
                    actuationOperation !== 16 &&
                    actuationOperation !== 17
                "
            >
                <mat-label>Médico</mat-label>
                <mat-select panelClass="cus-search-select" formControlName="Doctor">
                    <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                    (input)="SearchDoctors()" />
                    <div class="search-options">
                        <mat-option *ngFor="let medico of _medicoList" [value]="medico.value">
                            {{medico.viewValue}}
                        </mat-option>
                    </div>                   
                                    
                </mat-select>
                <mat-error
                            *ngIf="
                                GestionFormGroup.get(['Gestion', 'Doctor']) &&
                                GestionFormGroup.get(['Gestion', 'Doctor'])
                                    .invalid
                            "
                        >
                            <span
                                *ngIf="
                                    GestionFormGroup.get(['Gestion', 'Doctor']) &&
                                    GestionFormGroup.get(['Gestion', 'Doctor'])
                                        .errors.required
                                "
                                class="validation-span"
                                >Obligatorio</span
                            >
                        </mat-error>
            </mat-form-field>

            <div class="widget">

                <app-globle-author *ngIf="isShowAutor" 
                [gestionFormGroup]="GestionFormGroup.get('Gestion')" 
                [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')"  
                [moduleName]="responsibleModuleName" [authorTypes]="responsibleAuthorTypes" 
                [authComponentModel]="authComponentModel">
                </app-globle-author>
                <!-- <app-autor-selection
                    *ngIf="
                        actuationOperation === 7 ||
                        actuationOperation === 8 ||
                        actuationOperation === 9
                    "
                    [AutorFormControl]="
                        GestionFormGroup.get(['Gestion', 'AutorInput'])
                    "
                    [AutorOtherFormControl]="
                        GestionFormGroup.get(['Gestion', 'OtherAutorInput'])
                    "
                    (AutorSelected)="autorSelected($event)"
                    (AutorOtherSelected)="autorOtherSelected()"
                ></app-autor-selection> -->
            </div>

<!--             <mat-form-field
                class="example-full-width autor-section"
                floatLabel="always"
                *ngIf="actuationOperation === 10"
            >
                <mat-label>Autor</mat-label>
                <mat-select (selectionChange)="autorSelected($event)" formControlName="Autor">
                    <mat-option
                        *ngFor="let coordinador of coordinatorList"
                        [value]="coordinador.viewValue"
                    >
                        {{ coordinador.viewValue }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="
                        GestionFormGroup.get(['Gestion', 'Autor']) &&
                        GestionFormGroup.get(['Gestion', 'Autor']).invalid &&
                        GestionFormGroup.get(['Gestion', 'Autor']).touched
                    "
                >
                    <span
                        *ngIf="
                            GestionFormGroup.get(['Gestion', 'Autor']) &&
                            GestionFormGroup.get(['Gestion', 'Autor']).errors
                                .required
                        "
                        class="validation-span"
                        >Obligatorio</span
                    >
                </mat-error>
            </mat-form-field> -->

            <mat-form-field
                class="example-full-width m-t-10 textarea"
                floatLabel="always"
                *ngIf="
                    actuationOperation ===
                    ActuationOperationTypes.GestionConMutua
                "
            >
                <textarea
                    matInput
                    rows="7"
                    placeholder="Informe"
                    formControlName="Inform"
                ></textarea>
                <mat-error
                    *ngIf="
                        GestionFormGroup.get(['Gestion', 'Inform']) &&
                        GestionFormGroup.get(['Gestion', 'Inform']).invalid
                    "
                >
                    <span
                        *ngIf="
                            GestionFormGroup.get(['Gestion', 'Inform']) &&
                            GestionFormGroup.get(['Gestion', 'Inform']).errors
                                .required
                        "
                        class="validation-span"
                        >Obligatorio</span
                    >
                </mat-error>
            </mat-form-field>
            <mat-form-field
                class="example-full-width m-t-10 textarea"
                floatLabel="always"
                *ngIf="
                    actuationOperation ===
                        ActuationOperationTypes.InformeMedico ||
                    actuationOperation ===
                        ActuationOperationTypes.DocumentoNoMedico ||
                    actuationOperation === ActuationOperationTypes.Comentarios ||
                    actuationOperation === ActuationOperationTypes.SmsEntregado ||
                    actuationOperation === ActuationOperationTypes.SmsNoEntregado ||
                    actuationOperation === ActuationOperationTypes.SolicitarAlta ||
                    actuationOperation === ActuationOperationTypes.MantenerIt 
                "
            >
                <textarea
                    matInput
                    rows="7"
                    placeholder="Comentarios"
                    formControlName="Comments"
                ></textarea>
                <mat-error
                    *ngIf="
                        GestionFormGroup.get(['Gestion', 'Comments']) &&
                        GestionFormGroup.get(['Gestion', 'Comments']).invalid
                    "
                >
                    <span
                        *ngIf="
                            GestionFormGroup.get(['Gestion', 'Comments']) &&
                            GestionFormGroup.get(['Gestion', 'Comments']).errors
                                .required
                        "
                        class="validation-span"
                        >Obligatorio</span
                    >
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
